import { useCallback } from 'react'
import { gql, useQuery } from '@apollo/client'

const GET_JOB_QUERY = gql`
  query GetJobQuery($id: Int!) {
    getJob(id: $id) {
      id
      jobType
      status
      comparisonId
      diffUri
      originalUri
      revisedUri
      originalDesign {
        originalFilename
      }
      revisedDesign {
        originalFilename
      }
      quality
      createdAt
      startedAt
      downloadUrls
    }
  }
`

export interface Job {
  id: number
  jobType: string
  status: string
  comparisonId: string
  diffUri: string
  originalUri: string
  revisedUri: string
  originalDesign: {
    originalFilename: string
  }
  revisedDesign: {
    originalFilename: string
  }
  quality: number
  createdAt: string
  startedAt: string
  downloadUrls: {
    original: string
    revised: string
    thumbnail: string
    preview: string
    overlay: string
    diff: string
    diffOriginal: string
    reportCsv: string
  }
}

interface GetJobQueryResponse {
  getJob: Job
}

const useReviewQuery = (id: number) => {
  const { data, loading, error, refetch } = useQuery<GetJobQueryResponse>(GET_JOB_QUERY, {
    variables: { id },
    skip: id < 0
  })

  const refetchJob = useCallback(async () => {
    if (id < 0) return

    try {
      await refetch()
    } catch (error) {
      console.error(error)
    }
  }, [refetch, id])

  return {
    job: data?.getJob,
    loading,
    error,
    refetchJob
  }
}

export default useReviewQuery
